import http from './httpService';

export function fetchUserApi() {
  return http.get(`/account`);
}

// export function getAllComments() {
//   return http.get(`/comments`);
// }
// comments?riskId.equals=${id}&sort=createdAt,desc

export function getAllAudit(id) {
  return http.get(`/risk-audits?riskId.equals=${id}&sort=insertedAt,desc`);
}

// export function getAllAudit() {
//   return http.get(`/risk-audit?riskId.equals=1`);
// }